import {ADD, SET, UPDATE} from './actions';

const initialState = [];
export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.suppliers;

    case ADD:
      return [
        ...state,
        action.supplier
      ];

    case UPDATE:
      return [
        ...state.map(supplier => {
          if(supplier.id === action.supplier.id){
            return action.supplier
          }

          return supplier
        }),
      ];

    default:
      return state;
  }
};